export interface IQuickLinksPermissionDto {
    id?: number;
    certificates?: boolean;
    myCertificates?: boolean;
    declareShipment?:boolean;
    declareStorage?:boolean;
    requests?:boolean;
    favourites?:boolean;
    vesselScreening?:boolean;
    quickLinks?:QuickLinksPermissions;
   
}

export class QuickLinksPermissionDto implements IQuickLinksPermissionDto {
    constructor(
        public id?: number,
        public certificates?: boolean,
        public myCertificates?: boolean,
        public declareShipment?:boolean,
        public declareStorage?:boolean,
        public requests?:boolean,
        public favourites?:boolean,
        public vesselScreening?:boolean,
        public quickLinks?:QuickLinksPermissions
       

    ) {
      this.certificates = false;
      this.declareShipment = false;
      this.declareStorage = false;
      this.myCertificates = false;
      this.requests= false;
      this.favourites = false;
      this.vesselScreening = false;
     
    }
}

export const enum QuickLinksPermissions {
    GET_CERTIFICATE= 'Get Certificates',
	DECLARE_SHIPMENT = 'Declare Shipment',
	DECLARE_STORAGE = 'My Storages',
	MY_CERTIFICATES = 'My Certificates',
	REQUESTS = 'Requests',
	REQUEST_DETAILS = 'Request Details',
	FAVOURITES = 'Favourites',
	VESSEL_SCREENING = 'Vessel Screening',

}